exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sender .select2-container{max-width:480px}#sender .select2-container a.select2-choice{border:1px solid #999;font-size:1.15rem}", ""]);

// exports
